import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css';
const app = createApp(App);
let imgPrefix = '', prefix = '';
if (!window.location.origin.includes('.space')) {
    imgPrefix = 'https://show.eliteu.xyz/'
    prefix = 'https://ai4staff.dev.eliteu.cn/'
} else {
    imgPrefix = `${window.location.origin}/`
    prefix = 'https://ai4staff.eliteu.cn/'
}
app.config.globalProperties.$imgPrefix = imgPrefix;
app.config.globalProperties.$prefix = prefix;
app.use(store).use(router).use(Antd).mount('#app')
